var Shopify = Shopify || {};

const cartIcon = `<svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_308_849)">
    <path d="M8.74609 6.99927H38.4961L34.9961 26.2493M8.74609 6.99927L12.2461 26.2493H34.9961M8.74609 6.99927C8.45384 5.83202 6.99609 3.49927 3.49609 3.49927M34.9961 26.2493H9.14859C6.02659 26.2493 4.37109 27.616 4.37109 29.7493C4.37109 31.8825 6.02659 33.2493 9.14859 33.2493H34.1211" stroke="currentColor" stroke-width="2.625" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_308_849">
      <rect width="42" height="42" fill="none"/>
    </clipPath>
  </defs>
</svg>
`;

const backArrowIcon = `<svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M25.8008 9.31682L13.2591 21.8585L25.8008 34.4001" stroke="currentColor" stroke-width="2.15" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const removeLineIcon = `<svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9518 4.24651C16.6469 3.34879 15.8547 2.76782 14.9575 2.76782H10.5674L10.4005 2.77456C9.51805 2.84598 8.76499 3.47927 8.53307 4.36875L8.26974 5.71175L8.23888 5.82997C8.11278 6.21281 7.76024 6.47853 7.35755 6.47853L7.35643 6.47861H3.96924L3.8637 6.48589C3.48403 6.53871 3.19141 6.87244 3.19141 7.27627C3.19141 7.7168 3.53966 8.07393 3.96924 8.07393H21.5567L21.6622 8.06664C22.0419 8.01383 22.3345 7.68009 22.3345 7.27627C22.3345 6.83573 21.9863 6.47861 21.5567 6.47861H18.1784C18.1747 6.47856 18.1711 6.47853 18.1674 6.47853L18.0483 6.47071C17.6574 6.41905 17.3343 6.11651 17.2552 5.71143L17.0032 4.41848L16.9518 4.24651ZM15.862 6.47861C15.8266 6.38853 15.796 6.29572 15.7704 6.20048L15.7297 6.02437L15.489 4.78083C15.4328 4.56506 15.259 4.40709 15.0494 4.37097L14.9575 4.36314H10.5674C10.3492 4.36314 10.1552 4.49413 10.0746 4.65876L10.0473 4.7311L9.79519 6.02469C9.76443 6.18222 9.71987 6.33393 9.66298 6.47861H15.862ZM20.1858 9.9147C20.5784 9.94715 20.8792 10.2731 20.9001 10.6654L20.89 10.8842L20.5555 14.98L20.2046 18.977C20.1304 19.775 20.064 20.448 20.0066 20.9778C19.8073 22.8242 18.6087 23.9659 16.802 23.9997C13.9866 24.0517 11.2804 24.0512 8.65245 23.9944C6.89793 23.9575 5.71711 22.8034 5.5213 20.9853L5.38597 19.6458L5.14949 17.0475L4.90724 14.1963L4.63026 10.7737C4.59584 10.3346 4.91506 9.94998 5.34327 9.91468C5.73579 9.88232 6.08364 10.1547 6.1654 10.5385L6.19722 10.8522L6.4573 14.0608L6.74129 17.3866C6.86867 18.8263 6.97914 19.9914 7.06755 20.8099C7.17913 21.846 7.7247 22.3792 8.68477 22.3994C11.2922 22.4558 13.9782 22.4563 16.7738 22.4047C17.7922 22.3856 18.3464 21.8576 18.4604 20.802L18.5951 19.4697C18.6346 19.0591 18.6767 18.6058 18.7213 18.1134L19.0056 14.8426L19.348 10.6457C19.3797 10.2432 19.6975 9.93462 20.0801 9.91326L20.1858 9.9147Z" fill="currentColor"/>
</svg>`;

const plusIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.65723 6.84033V12.4743" stroke="currentColor" stroke-width="1.20728" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.84082 9.65723H12.4748" stroke="currentColor" stroke-width="1.20728" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const minusIcon = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.65332 9.65698H13.2873" stroke="currentColor" stroke-width="1.20728" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const plusWithNoSpaceIcon = `<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.8828 5.0665H7.42969V0.723786C7.42969 0.531826 7.35149 0.347728 7.21231 0.211992C7.07312 0.076256 6.88434 0 6.6875 0C6.49066 0 6.30188 0.076256 6.16269 0.211992C6.02351 0.347728 5.94531 0.531826 5.94531 0.723786V5.0665H1.49219C1.29535 5.0665 1.10657 5.14276 0.967382 5.2785C0.828195 5.41423 0.75 5.59833 0.75 5.79029C0.75 5.98225 0.828195 6.16635 0.967382 6.30208C1.10657 6.43782 1.29535 6.51408 1.49219 6.51408H5.94531V10.8568C5.94531 11.0488 6.02351 11.2329 6.16269 11.3686C6.30188 11.5043 6.49066 11.5806 6.6875 11.5806C6.88434 11.5806 7.07312 11.5043 7.21231 11.3686C7.35149 11.2329 7.42969 11.0488 7.42969 10.8568V6.51408H11.8828C12.0797 6.51408 12.2684 6.43782 12.4076 6.30208C12.5468 6.16635 12.625 5.98225 12.625 5.79029C12.625 5.59833 12.5468 5.41423 12.4076 5.2785C12.2684 5.14276 12.0797 5.0665 11.8828 5.0665Z" fill="currentColor"/>
</svg>`;

Shopify.money_format = `${window.countryCurrency.symbol}{{amount}}`;
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function setupEventInterceptor(elements, eventType, callback) {
  function eventInterceptor(event) {
    const targetElement = event.target.closest(elements.join(', '));

    if (targetElement) {
      event.preventDefault();

      if (typeof callback === 'function') {
        callback(targetElement);
      } else {
        console.error('Callback is not a function!');
      }

      event.stopImmediatePropagation();
    }
  }

  document.body.addEventListener(eventType, eventInterceptor, {
    capture: true,
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// api
function getFetchPostConfig(body, type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
    body,
  };
}

async function getCart() {
  try {
    const res = await fetch(`${window.Shopify.routes.root + 'cart.json'}`);

    if (!res.ok) {
      throw new Error('HTTP error: ', res.status);
    }

    return await res.json();
  } catch (error) {
    console.error(error.message);
  }
}

class VooCart {
  constructor() {
    this.renderCartDrawer();
    this.addBackToCartListener();
  }

  scrollPosition = window.scrollY;

  addBackToCartListener() {
    const backToCartBtnEl = document.querySelector('.voo-cart-drawer__quick-buy-back-btn');

    if (backToCartBtnEl)
      backToCartBtnEl.addEventListener('click', () => {
        const quickBuyDrawerEl = document.querySelector('.voo-cart-drawer__quick-buy-drawer');
        quickBuyDrawerEl.classList.remove('open');
      });
  }

  getEmptyInnerContentMarkup() {
    const {
      heading,
      continueLink = '/collections/all',
      continueLinkTitle,
      emptyCartHeading,
      emptyCartMessage,
      emptyCartImage,
    } = VOOCART.config.settings;

    return `<div class="voo-cart-drawer__inner--empty">
          <button
            class="voo-cart-drawer__close voo-btn"
            type="button"
            data-voocart-close
            aria-label="Close"
          >
            ${backArrowIcon}
          </button>
        <div class="voo-cart-drawer__inner--empty-card">
          <h2 class="voo-cart-drawer__inner--empty-title">${emptyCartHeading}</h2>
          ${emptyCartMessage ? `<div class="voo-cart-drawer__inner--empty-msg">${emptyCartMessage}</div>` : ''}
          ${emptyCartImage
        ? ` <div class="voo-cart-drawer__inner--empty-img-wrap">
                <img class="voo-cart-drawer__inner--empty-img" src="${emptyCartImage}" width="113"/>
              </div>`
        : ''
      }
        </div>
        <a class="voo-cart-drawer__inner--empty-continue voo-link" href="${continueLink}">${continueLinkTitle}</a>
      </div>`;
  }

  renderCartDrawer() {
    const { cartType, heading, footerNote } = VOOCART.config.settings;
    const cartDrawerBasicMarkup = `
    <voo-cart-drawer class="${cartType === 'drawer' ? 'voo-drawer' : 'voo-modal'}">
      <div class="voo-cart-drawer">
        <div class="voo-cart-drawer__overlay"></div>
        <div
          class="voo-cart-drawer__inner"
          role="dialog"
          aria-modal="true"
          aria-label="Cart"
          tabindex="-1"
        >

          ${this.getEmptyInnerContentMarkup()}

          <div class="voo-cart-drawer__inner-content">
            <div class="voo-cart-drawer__header">
              <h2 class="voo-cart-drawer__heading">
                ${cartIcon}
                ${heading ? heading : 'Cart'}
              </h2>
              <button
                class="voo-cart-drawer__close voo-btn"
                type="button"
                data-voocart-close
                aria-label="Close"
              >
                ${backArrowIcon}
              </button>
            </div>
            <div class="voo-cart-drawer__body"></div>
            <div class="voo-cart-drawer__footer">
              <div class="voo-cart-drawer__cta-btns-wrap">
                <a
                  class="voo-cart-drawer__cta-checkout voo-btn"
                  href="${window.Shopify.routes.root}checkout"
                >
                  Checkout -
                  <span class="voo-cart-drawer__cta-checkout-total"></span>
                </a>
              </div>
              ${footerNote ? `<p class="voo-cart-drawer__cta-btns-note">${footerNote}</p>` : ''}
            </div>
            <div class="voo-cart-drawer__quick-buy-drawer">
              <button class="voo-cart-drawer__quick-buy-back-btn" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                  <path d="M1.63136 5.45007H12.9348C13.0847 5.45007 13.2285 5.50801 13.3345 5.61114C13.4405 5.71427 13.5 5.85415 13.5 6C13.5 6.14585 13.4405 6.28573 13.3345 6.38886C13.2285 6.49199 13.0847 6.54993 12.9348 6.54993H1.63136C1.48146 6.54993 1.33771 6.49199 1.23172 6.38886C1.12573 6.28573 1.06618 6.14585 1.06618 6C1.06618 5.85415 1.12573 5.71427 1.23172 5.61114C1.33771 5.50801 1.48146 5.45007 1.63136 5.45007Z" fill="currentColor"/>
                  <path d="M1.86534 6L6.55289 10.56C6.65901 10.6633 6.71863 10.8033 6.71863 10.9494C6.71863 11.0954 6.65901 11.2355 6.55289 11.3387C6.44676 11.442 6.30283 11.5 6.15274 11.5C6.00266 11.5 5.85873 11.442 5.7526 11.3387L0.666041 6.38935C0.613408 6.33827 0.57165 6.27758 0.543158 6.21077C0.514666 6.14396 0.5 6.07233 0.5 6C0.5 5.92767 0.514666 5.85604 0.543158 5.78923C0.57165 5.72242 0.613408 5.66173 0.666041 5.61065L5.7526 0.661274C5.85873 0.558012 6.00266 0.5 6.15274 0.5C6.30283 0.5 6.44676 0.558012 6.55289 0.661274C6.65901 0.764537 6.71863 0.90459 6.71863 1.05063C6.71863 1.19666 6.65901 1.33671 6.55289 1.43998L1.86534 6Z" fill="currentColor"/>
                </svg>
                ${'Back to cart'}
              </button>
              <div class="voo-cart-drawer__quick-buy-product-info-wrap"></div>
            <div>
          </div>
        </div>
      </div>
    </voo-cart-drawer>
    `;

    document.body.insertAdjacentHTML('afterbegin', cartDrawerBasicMarkup);
  }
}

class VooCartDrawer extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  async productSubmitHandler() {
    await this.addUpsellProducts();
    await this.renderDynamicContent();
    this.open();
  }

  async addUpsellProducts() {
    const complementaryWrapEl = document.querySelector('.t4s-complimentary');

    if (!complementaryWrapEl) return;

    const checkedCheckboxElems = [
      ...complementaryWrapEl.querySelectorAll('.complementary-products--item-checkbox'),
    ].filter((checkboxEl) => checkboxEl.checked);

    if (checkedCheckboxElems.length === 0) return;

    const variantsDataForAddingToCart = checkedCheckboxElems.map((checkboxEl) => {
      const variantId = Number(
        checkboxEl
          .closest('.complementary-products--item-wr')
          ?.querySelector('.complementary-products--item-options-select').value
      );

      return {
        id: variantId,
        quantity: 1,
      };
    });

    await this.addProducts(variantsDataForAddingToCart);
  }

  renderCartDrawerBodyContent() {
    const blockOrder = VOOCART.config.blockOrder;

    const cartDarwerBodyContentMarkup = blockOrder.reduce((markup, blockType) => {
      switch (blockType) {
        case 'announcement_bar':
          return markup + this.getAnnouncementBarMarkup();
        case 'free-gift':
          return markup + this.getFreeGiftBlockMarkup();
        case 'cart_items':
          return markup + this.getCartDrawerItemsMarkup();
        case 'bogo':
          return markup + this.getBogoBlockMarkup();
        case 'recommendations':
          return markup + this.getRecommendationsBlockMarkup();
        case 'cart-drawer-note':
          return markup + this.getCartDrawerNoteMarkup();
        case 'reward-bar':
          return markup + this.getRewardBarMarkup();
        case 'discount_applicator':
          return markup + this.getDiscountBlockMarkup();
        default:
          return markup;
      }
    }, '');

    this.checkIfCartIsEmpty();
    document.querySelector('.voo-cart-drawer__body').innerHTML = cartDarwerBodyContentMarkup;
  }

  addOpenCartListeners() {
    document.querySelectorAll('[href$="/cart"], [data-voocart-open]').forEach((e) => {
      e.addEventListener('click', (e) => {
        if (!e.currentTarget.classList.contains('voo-cart-drawer__cart-link')) {
          e.preventDefault();
        }
        this.open();
      });
    });
  }

  addCloseCartListeners() {
    document.querySelectorAll('[data-voocart-close]').forEach((e) => {
      e.addEventListener('click', (e) => {
        e.preventDefault();
        this.close(e);
      });
    });
  }

  interceptProductSubmit() {
    const formsToInterceptSubmit = ['form[action*="/cart/add"]'];
    const customSubmitHandler = async (form) => {
      const qtyFromInput = document.querySelector('input[name="quantity"]')?.value;
      const sellingPlanSelectValue = Number(document.querySelector('[name="selling_plan"]')?.value);
      const variantId = Number(form.querySelector('input[name="id"]')?.value);
      const quantity = qtyFromInput ? qtyFromInput : 1;

      const productToAddOptions = { id: variantId, quantity };
      let productsToAddData = [productToAddOptions];
      if (sellingPlanSelectValue) {
        productsToAddData = [{ ...productToAddOptions, selling_plan: sellingPlanSelectValue }];
      }

      const checkedComplementaryProductsCheckboxElems = document.querySelectorAll('.card__upsell-checkbox:checked');

      if (checkedComplementaryProductsCheckboxElems.length > 0) {
        checkedComplementaryProductsCheckboxElems.forEach((checkboxEl) => {
          const complementaryItemEl = checkboxEl.closest('.card-product__upsell-item');
          const variantId = Number(complementaryItemEl.dataset.complementaryVariantId);
          const variantQuantity = 1;

          productsToAddData.unshift({
            id: variantId,
            quantity: variantQuantity,
          });
        });
      }

      await this.addProducts(productsToAddData);
    };

    setupEventInterceptor(formsToInterceptSubmit, 'submit', customSubmitHandler);
  }

  addOverlayEventListeners() {
    const overlayEl = this.querySelector('.voo-cart-drawer__overlay');
    document.addEventListener('keyup', (e) => e.code === 'Escape' && this.close(e));

    if (overlayEl) overlayEl.addEventListener('click', this.close.bind(this));
  }

  open() {
    setTimeout(() => {
      this.classList.add('animate', 'open');
    });

    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      this.scrollPosition = window.scrollY;
      document.body.classList.add('voo-body-prevent-scroll');
      document.body.style.top = `-${this.scrollPosition}px`;
    } else {
      document.body.classList.add('voo-overflow-hidden');
    }
  }

  close(e) {
    e.stopImmediatePropagation();
    this.classList.remove('open');

    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      document.body.classList.remove('voo-body-prevent-scroll');
      document.body.style.removeProperty('top');
      window.scrollTo({ top: this.scrollPosition, behavior: 'instant' });
    } else {
      document.body.classList.remove('voo-overflow-hidden');
    }
  }

  async renderDynamicContent() {
    await this.updateStickyBubble();
    await this.updateHeaderCounter();
    await this.checkIfCartIsEmpty();
    await this.renderCartDrawerItems();
    await this.renderCartDrawerFooter();

    const rewardBarEl = document.querySelector('voo-cart-drawer-reward-bar');
    const freeGiftEl = document.querySelector('voo-cart-drawer-free-gift');
    const bogoEl = document.querySelector('voo-cart-drawer-bogo');
    const recommendationsEl = document.querySelector('voo-cart-drawer-recommendations');

    if (rewardBarEl) rewardBarEl.updateRewardBar();
    if (freeGiftEl) freeGiftEl.updateFreeGiftMessage();
    if (bogoEl) bogoEl.productVariantsToCheckInCartForGift();
    if (recommendationsEl) recommendationsEl.renderRecommendations();
  }

  async changeItemsQuantity(updates) {
    try {
      const body = JSON.stringify({ updates });
      await fetch(`${window.Shopify.routes.root}cart/update.js`, getFetchPostConfig(body));
    } catch (error) {
      console.error(error);
    }
  }

  async removeStartersetProducts() {
    const cart = await getCart();
    const startersetProducts = cart.items.filter((item) => item.properties._startset);

    if (startersetProducts.length === 0) return;

    const itemsToRemoveUpdatedData = startersetProducts.reduce((acc, item) => {
      acc[item.id] = 0;
      return acc;
    }, {});

    await this.changeItemsQuantity(itemsToRemoveUpdatedData);
  }

  async init() {
    const { showStickyCart } = VOOCART.config.settings;

    await this.removeStartersetProducts();

    if (showStickyCart) {
      this.renderStickyCart();
      this.updateStickyBubble();
    }

    this.updateHeaderCounter();
    this.addOpenCartListeners();
    this.addOverlayEventListeners();
    this.interceptProductSubmit();
    this.updateCartDrawerFooterMarkup();
    this.addCloseCartListeners();

    this.renderCartDrawerBodyContent();
  }

  async addProducts(itemsToAdd) {
    const body = JSON.stringify({
      items: itemsToAdd,
    });

    await fetch(`${window.Shopify.routes.root}cart/add`, getFetchPostConfig(body));

    await this.renderDynamicContent();
    this.open();
  }

  async removeProducts(itemsToRemove) {
    const body = JSON.stringify({
      updates: itemsToRemove.reduce((acc, item) => {
        acc[item.id] = 0;
        return acc;
      }, {}),
    });

    await fetch(`${window.Shopify.routes.root}cart/update`, getFetchPostConfig(body));

    await this.renderDynamicContent();
    this.open();
  }

  getCartDrawerNoteMarkup() {
    const isCollapsible = VOOCART.config.blocks.cartDrawerNote.settings.isCollapsible;

    return `
      <voo-cart-note>
        <div class="voo-cart-drawer__note-wrap">
          ${isCollapsible
        ? '<button type="button" class="voo-cart-drawer__note-trigger voo-btn">Write a note</button>'
        : ''
      }
          <textarea
            id="voo-cart-drawer-note"
            class="voo-cart-drawer__note-textarea ${isCollapsible ? 'voo-hidden' : ''}"
            placeholder="${'Enter special instructions for seller'}"
          >${''}</textarea>
        </div>
      </voo-cart-note>
    `;
  }

  getAnnouncementBarMarkup() {
    const { announcementAutoplay, announcementMessages } = VOOCART.config.blocks.announcementBar.settings;

    return `<voo-cart-drawer-announcement class="voo-cart-drawer__announcement-bar" ${announcementAutoplay ? 'data-autoplay="true"' : ''
      }>
      <ul class="siema voo-cart-drawer__announcement-list voo-list">${announcementMessages.reduce(
        (markup, message) => markup + `<li class="voo-cart-drawer__announcement-item">${message}</li>`,
        ''
      )}</ul>

      <button class="voo-btn voo-cart-drawer__announcement-btn prev">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.07005 12.543L16.4296 20.508C16.569 20.641 16.7543 20.7151 16.9471 20.7151C17.1398 20.7151 17.3251 20.641 17.4646 20.508L17.4736 20.499C17.5414 20.4345 17.5954 20.357 17.6324 20.271C17.6693 20.185 17.6883 20.0923 17.6883 19.9988C17.6883 19.9052 17.6693 19.8126 17.6324 19.7266C17.5954 19.6406 17.5414 19.563 17.4736 19.4985L9.60155 11.9985L17.4736 4.50151C17.5414 4.43705 17.5954 4.35946 17.6324 4.27346C17.6693 4.18746 17.6883 4.09485 17.6883 4.00126C17.6883 3.90767 17.6693 3.81506 17.6324 3.72906C17.5954 3.64306 17.5414 3.56547 17.4736 3.50101L17.4646 3.49201C17.3251 3.35904 17.1398 3.28486 16.9471 3.28486C16.7543 3.28486 16.569 3.35904 16.4296 3.49201L8.07005 11.457C7.99653 11.5271 7.93801 11.6113 7.89801 11.7046C7.85802 11.798 7.8374 11.8985 7.8374 12C7.8374 12.1016 7.85802 12.202 7.89801 12.2954C7.93801 12.3887 7.99653 12.473 8.07005 12.543Z" fill="currentColor"/>
        </svg>
      </button>
      <button class="voo-btn voo-cart-drawer__announcement-btn next">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.9304 11.457L7.57094 3.49199C7.43145 3.35903 7.24614 3.28485 7.05344 3.28485C6.86073 3.28485 6.67542 3.35903 6.53594 3.49199L6.52694 3.50099C6.45908 3.56545 6.40505 3.64304 6.36813 3.72904C6.33121 3.81504 6.31217 3.90765 6.31217 4.00124C6.31217 4.09483 6.33121 4.18745 6.36813 4.27344C6.40505 4.35944 6.45908 4.43703 6.52694 4.50149L14.3989 12.0015L6.52694 19.4985C6.45908 19.563 6.40505 19.6405 6.36813 19.7265C6.33121 19.8125 6.31217 19.9052 6.31217 19.9987C6.31217 20.0923 6.33121 20.1849 6.36813 20.2709C6.40505 20.3569 6.45908 20.4345 6.52694 20.499L6.53594 20.508C6.67542 20.641 6.86073 20.7151 7.05344 20.7151C7.24614 20.7151 7.43145 20.641 7.57094 20.508L15.9304 12.543C16.004 12.4729 16.0625 12.3887 16.1025 12.2954C16.1425 12.202 16.1631 12.1015 16.1631 12C16.1631 11.8984 16.1425 11.798 16.1025 11.7046C16.0625 11.6113 16.004 11.527 15.9304 11.457Z" fill="currentColor"/>
        </svg>
      </button>
    </voo-cart-drawer-announcement>
    `;
  }

  getRecommendationsBlockMarkup() {
    const { heading, headingMob, navMode, navModeMob } = VOOCART.config.blocks.recommendations.settings;
    const isMobile = window.innerWidth < 768;
    const sliderNavigationMode = isMobile ? navModeMob : navMode;

    return `<voo-cart-drawer-recommendations>
        <h3 class="voo-cart-drawer__recommendations-title voo-desk voo-cart-drawer__block-title">${heading}</h3>
        <h3 class="voo-cart-drawer__recommendations-title voo-mob voo-cart-drawer__block-title">${headingMob}</h3>
        <div class="voo-cart-drawer__recommendations-list-wrapper">
          <ul class="voo-cart-drawer__recommendations-list voo-list"></ul>
           ${sliderNavigationMode === 'slider' ? '<div class="voo-cart-drawer__recommendations-nav-wrap"></div>' : ''}
        </div>
      </voo-cart-drawer-recommendations>`;
  }

  getDiscountBlockMarkup() {
    const { inputPlaceholder, applyBtnText } = VOOCART.config.blocks.discountApplicator.settings;

    return `<voo-cart-drawer-discount id="CartDrawerDiscount">
      <div class="cart-sidebar-discount">
        <div class="discount-code-wrap">
          <div class="discount-code-input-wrap">
            <input type="text" id="discount-code-input" autocomplete="on" value="" placeholder="${inputPlaceholder}">
            <button id="apply-discount-btn">${applyBtnText}</button>
          </div>
          <small id="discount-code-error"></small>
        </div>
      </div>
    </voo-cart-drawer-discount>`;
  }

  getBogoBlockMarkup() {
    return `
      <voo-cart-drawer-bogo>
        <h3 class="voo-cart-drawer__bogo-title voo-cart-drawer__block-title">Pick your gift</h3>
        <ul class="voo-cart-drawer__bogo-list voo-list"></ul>
      </voo-cart-drawer-bogo>
    `;
  }

  getRewardBarMarkup() {
    return `
      <voo-cart-drawer-reward-bar>
        <div class="voo-cart-drawer__reward-bar-wrap">
          <div class="voo-cart-drawer__reward-bar-message-wrap">
            <div class="voo-cart-drawer__reward-bar-message">
              <p class="voo-cart-drawer__reward-bar-message-applied voo-hidden"></p>
              <p class="voo-cart-drawer__reward-bar-message-spend">Spend <span class="money-to-spend money"></p>
            </div>
          </div>
          <div class="voo-cart-drawer__reward-bar-line-wrap">
            <span class="voo-cart-drawer__reward-bar-line"></span>
          </div>
        </div>
      </voo-cart-drawer-reward-bar>
    `;
  }

  async getProductVariantData(variantId) {
    try {
      const res = await fetch(`${window.Shopify.routes.root}variants/${variantId}.js`);
      if (!res.ok) {
        throw new Error('HTTP error: ', res.status);
      }

      return await res.json();
    } catch (error) {
      console.error(error.message);
    }
  }

  getFreeGiftBlockMarkup() {
    return `
      <voo-cart-drawer-free-gift>
        <div class="voo-cart-drawer__gift-message-wrapper">
          <div class="voo-cart-drawer__gift-img-wrapper">
            <img class="voo-cart-drawer__gift-img" src="" alt="" width="50" height="50">
            <span class="voo-cart-drawer__gift-label">GRATIS</span>
          </div>
          <p class="voo-cart-drawer__gift-message">
            Continue shopping on
            <span class="voo-cart-drawer__gift-total-left money"></span>
            and
            <span class="voo-cart-drawer__gift-message--accent"> get
              <span class="voo-cart-drawer__gift-name"></span>
              as a gift!
            </span>
            </p>
        </div>
      </voo-cart-drawer-free-gift>
    `;
  }

  renderStickyCart() {
    const { stickyCartVerticalAlign = 'center', stickyCartHorizontalAlign = 'right' } = VOOCART.config.settings;

    const stickyCartBtnMarkup = `
    <style>
      ${stickyCartVerticalAlign === 'center'
        ? `
        .voo-cart-drawer__sticky-btn {
          bottom: 50%;
          ${stickyCartHorizontalAlign === 'right' ? 'right: 24px;' : 'left: 24px;'}
          transform: translateY(50%);
        }

        .voo-cart-drawer__sticky-btn:hover {
          transform: translateY(50%) scale(1.05);
        }`
        : `
        .voo-cart-drawer__sticky-btn {
          bottom: 24px;
          ${stickyCartHorizontalAlign === 'right' ? 'right: 24px;' : 'left: 24px;'}
        }

        .voo-cart-drawer__sticky-btn:hover {
          transform: scale(1.05);
        }`
      }
    </style>

    <button type="button" class="voo-cart-drawer__sticky-btn voo-btn">
      <svg
        fill="currentColor"
        width="24"
        height="24"
        viewBox="0 0 902.86 902.86"
      >
        <g>
          <g>
            <path d="M671.504,577.829l110.485-432.609H902.86v-68H729.174L703.128,179.2L0,178.697l74.753,399.129h596.751V577.829z
              M685.766,247.188l-67.077,262.64H131.199L81.928,246.756L685.766,247.188z"/>
            <path d="M578.418,825.641c59.961,0,108.743-48.783,108.743-108.744s-48.782-108.742-108.743-108.742H168.717
              c-59.961,0-108.744,48.781-108.744,108.742s48.782,108.744,108.744,108.744c59.962,0,108.743-48.783,108.743-108.744
              c0-14.4-2.821-28.152-7.927-40.742h208.069c-5.107,12.59-7.928,26.342-7.928,40.742
              C469.675,776.858,518.457,825.641,578.418,825.641z M209.46,716.897c0,22.467-18.277,40.744-40.743,40.744
              c-22.466,0-40.744-18.277-40.744-40.744c0-22.465,18.277-40.742,40.744-40.742C191.183,676.155,209.46,694.432,209.46,716.897z
              M619.162,716.897c0,22.467-18.277,40.744-40.743,40.744s-40.743-18.277-40.743-40.744c0-22.465,18.277-40.742,40.743-40.742
              S619.162,694.432,619.162,716.897z"/>
          </g>
        </g>
      </svg>
      <span class="voo-cart-drawer__sticky-bubble hidden"></span>
    </button>
  `;

    document.body.insertAdjacentHTML('afterbegin', stickyCartBtnMarkup);
    const stickyBtnEl = document.querySelector('.voo-cart-drawer__sticky-btn');

    if (stickyBtnEl) stickyBtnEl.addEventListener('click', this.open.bind(this));
  }

  async updateHeaderCounter(count) {
    let itemCount = count;
    const headerCounterEl = document.querySelector('[data-cart-count]');
    const headerConterWrapEl = document.querySelector('.cart-count-bubble');

    if (!headerCounterEl) return;

    if (!itemCount) {
      const cart = await getCart();
      itemCount = cart.item_count;
    }

    if (itemCount === 0) {
      headerConterWrapEl.classList.add('cart-count-bubble--hidden');
    } else {
      headerConterWrapEl.classList.remove('cart-count-bubble--hidden');
      headerCounterEl.innerText = itemCount;
    }
  }

  async updateStickyBubble(count) {
    let itemCount = count;
    const stickyBubbleEl = document.querySelector('.voo-cart-drawer__sticky-bubble');

    if (!stickyBubbleEl) return;

    if (!itemCount) {
      const cart = await getCart();
      itemCount = cart.item_count;
    }

    if (itemCount === 0) {
      stickyBubbleEl.classList.add('hidden');
    } else {
      stickyBubbleEl.classList.remove('hidden');
      stickyBubbleEl.innerText = itemCount;
    }
  }

  async checkIfCartIsEmpty(cart) {
    let cartItemsLength;
    const cartDrawerInnerEl = document.querySelector('.voo-cart-drawer__inner');

    if (!cartDrawerInnerEl) return;

    if (cart) {
      cartItemsLength = cart.items.length;
    } else {
      const fetchedCart = await getCart();
      cartItemsLength = fetchedCart.items.length;
    }

    if (cartItemsLength === 0) {
      cartDrawerInnerEl.classList.add('is-empty');
    } else {
      cartDrawerInnerEl.classList.remove('is-empty');
    }
  }

  async updateQuantity(line, quantity) {
    const currentLineProductVariantId = Number(
      document.querySelector(`[data-line-index="${line}"]`)?.dataset.variantId
    );

    const body = JSON.stringify({
      line,
      quantity,
    });

    const cartChangeRes = await fetch(`${window.Shopify.routes.root}cart/change`, getFetchPostConfig(body));

    const updatedCart = await cartChangeRes.json();

    this.checkIfCartIsEmpty(updatedCart);
    const vooCartDrawerItemsEl = this.querySelector('voo-cart-drawer-items');

    const variantsId = updatedCart.items.map((product) => product.variant_id);
    const uniqueVariantsId = new Set(variantsId);
    const hasItemsWithSameVariantId = variantsId.length !== uniqueVariantsId.size;

    if (quantity === 0 || hasItemsWithSameVariantId || !vooCartDrawerItemsEl) {
      this.renderCartDrawerItems();
    } else {
      vooCartDrawerItemsEl.updateLineProductItem(updatedCart, currentLineProductVariantId, line);
    }

    const cartDrawerEl = document.querySelector('voo-cart-drawer');
    const freeGiftEl = document.querySelector('voo-cart-drawer-free-gift');
    const bogoEl = document.querySelector('voo-cart-drawer-bogo');
    const rewardBarEl = document.querySelector('voo-cart-drawer-reward-bar');

    if (quantity === 0) {
      const recommendationsEl = document.querySelector('voo-cart-drawer-recommendations');

      if (recommendationsEl) recommendationsEl.renderRecommendations();
    }

    if (cartDrawerEl) cartDrawerEl.renderCartDrawerFooter();
    if (freeGiftEl) freeGiftEl.updateFreeGiftMessage();
    if (rewardBarEl) rewardBarEl.updateRewardBar();
    if (bogoEl) bogoEl.productVariantsToCheckInCartForGift();

    this.updateStickyBubble(updatedCart.item_count);
    this.updateHeaderCounter(updatedCart.item_count);
  }

  getLineProductMarkup(lineProduct, index) {
    const productLink = `${location.origin}/products/${lineProduct.handle}`;

    return `<li class="voo-cart-drawer__item" data-variant-id="${lineProduct.variant_id}" data-line-key="${lineProduct.key
      }" data-line-index="${index + 1}">
      <div class="voo-cart-drawer__item-content-wrap">
            <div class="voo-cart-drawer__img-wrap">
              <a href="${productLink}" class="voo-cart-drawer__img-link">
                <img
                  class="voo-cart-drawer__img"
                  src="${lineProduct.image}"
                  alt=""
                  width="70"
                  height="70"
                >
              </a>
            </div>
            <div class="voo-cart-drawer__item-content">
              <div class="voo-cart-drawer__top">
                <div class="voo-cart-drawer__item-name-wrap">
                  <h3 class="voo-cart-drawer__item-name">
                    <a href="${productLink}" class="voo-cart-drawer__item-name-link voo-link">
                      ${lineProduct.title}
                    </a>
                  </h3>
                  <p class="voo-cart-drawer__item-properties">${lineProduct.variant_title}</p>
                  <ul class="voo-cart-drawer__item-properties-list voo-list">
                    ${lineProduct.product_has_only_default_variant
        ? ''
        : lineProduct.options_with_values.reduce(
          (markup, option) =>
            markup +
            `<li class="voo-cart-drawer__item-property"><strong>${option.name}</strong>: ${option.value}</li>`,
          ''
        )
      }
                  </ul>
                  ${lineProduct.line_level_discount_allocations.length > 0
        ? `<span class="voo-cart-drawer__item-discount">
                    <ul class="voo-cart-drawer__item-discount-list voo-list">
                      ${lineProduct.line_level_discount_allocations.reduce(
          (markup, discount) =>
            markup + discount.amount > 0
              ? `<li class="voo-cart-drawer__item-discount-name">
                              <svg aria-hidden="true" focusable="false" width="12" height="12" class="icon icon-discount" viewBox="0 0 12 12">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
                              </svg>
                              ${discount.discount_application.title} ${`(-${Shopify.formatMoney(discount.amount)})`}
                              </li >`
              : '',
          ''
        )}
                    </ul>
                  </span>`
        : ''
      }
                </div>
                <button class="voo-cart-drawer__item-remove voo-btn">
                  ${removeLineIcon}
                </button>
              </div>
              <div class="voo-cart-drawer__bottom">
                <div class="voo-cart-drawer__item-quantity">
                  <button class="voo-cart-drawer__item-decrease voo-btn" ${lineProduct.quantity === 1 ? 'disabled' : ''
      } data-change-type="decrease">
                    ${minusIcon}
                  </button>
                  <input class="voo-cart-drawer__item-quantity-input" type="text" value="${lineProduct.quantity}">
                  <button class="voo-cart-drawer__item-increase voo-btn" data-change-type="increase">
                    ${plusIcon}
                  </button>
                </div>
                <div class="voo-cart-drawer__item-prices-wrap">
                  <span class="voo-cart-drawer__item-prices--original">
                    ${lineProduct.original_line_price === lineProduct.final_line_price
        ? ''
        : Shopify.formatMoney(lineProduct.original_line_price)
      }
                  </span>
                  <span class="voo-cart-drawer__item-prices--final">${Shopify.formatMoney(
        lineProduct.final_line_price
      )}</span>
                </div>
              </div>
            </div>
            </div>
          </li>
    `;
  }

  getCartDrawerItemsMarkup() {
    return `<voo-cart-drawer-items>
      <div class="voo-cart-drawer__items-wrap">
        <ul class="voo-cart-drawer__items voo-list"></ul>
      </div>
    </voo-cart-drawer-items>`;
  }

  async renderCartDrawerItems() {
    const cart = await getCart();

    const cartItemsMarkup = cart.items.reduce(
      (markup, item, index) => markup + this.getLineProductMarkup(item, index),
      ''
    );

    const cartDrawerItemsEl = document.querySelector('.voo-cart-drawer__items');

    if (cartDrawerItemsEl) cartDrawerItemsEl.innerHTML = cartItemsMarkup;

    document
      .querySelectorAll('.voo-cart-drawer__item-remove')
      .forEach((btn) => btn.addEventListener('click', this.removeLineProduct.bind(this)));

    document
      .querySelectorAll('[data-change-type]')
      .forEach((btn) => btn.addEventListener('click', this.changeLineProductQuantity.bind(this)));

    document
      .querySelectorAll('.voo-cart-drawer__item-quantity-input')
      .forEach((input) => input.addEventListener('change', this.updateLineQuantity.bind(this)));
  }

  async removeLineProduct(e) {
    const currentProductLineIndex = e.target.closest('.voo-cart-drawer__item')?.dataset.lineIndex;
    await this.updateQuantity(currentProductLineIndex, 0);
  }

  async changeLineProductQuantity(e) {
    const cartDrawerItem = e.target.closest('.voo-cart-drawer__item');
    const changeBtnEl = e.target.nodeName === 'BUTTON' ? e.target : e.target.closest('[data-change-type]');

    const currentQuantity = Number(cartDrawerItem.querySelector('.voo-cart-drawer__item-quantity-input')?.value);

    const newQuantity = changeBtnEl.dataset.changeType === 'decrease' ? currentQuantity - 1 : currentQuantity + 1;

    await this.updateQuantity(cartDrawerItem.dataset.lineIndex, newQuantity);
  }

  async updateLineQuantity(e) {
    const currentProductLineIndex = e.target.closest('.voo-cart-drawer__item')?.dataset.lineIndex;
    const newQuantity = Number(e.target.value);

    await this.updateQuantity(currentProductLineIndex, newQuantity);
  }

  async updateCartDrawerFooterMarkup() {
    this.renderCartDrawerFooter();
  }

  async renderCartDrawerFooter() {
    const cartDrawerFooterEl = document.querySelector('.voo-cart-drawer__footer');
    const { discountAppliedText, subtotalText, checkoutBtnText } = VOOCART.config.settings;

    if (!cartDrawerFooterEl) return;

    const cart = await getCart();
    const appliedCodesToLineItems = cart.items.flatMap((item) =>
      item.line_level_discount_allocations.filter(
        (discount) => discount.amount > 0 && discount.discount_application.type === 'discount_code'
      )
    );


    const cartDrawerFooterInnerMarkup = `
    ${cart.total_discount !== 0
        ? `<div class="voo-cart-drawer__footer-discounts-wrap">
    ${cart.cart_level_discount_applications.length > 0 || appliedCodesToLineItems.length > 0
          ? `
        <ul class="voo-cart-drawer__footer-discounts voo-list" role="list" aria-label="Discount">
          ${cart.cart_level_discount_applications.reduce(
            (markup, discount) =>
              markup +
              `<li class="voo-cart-drawer__footer-discounts-item">
              <svg aria-hidden="true" width="12" height="12" focusable="false" class="icon icon-discount" viewBox="0 0 12 12">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                </path>
              </svg>
              ${discount.title}
              (-<span class="money">${Shopify.formatMoney(discount.total_allocated_amount)}</span>)
              <button class="clear-discount-btn" data-code="${discount.title}"></button>
              </li>`,
            ''
          )}
          ${appliedCodesToLineItems.reduce(
            (markup, discount) =>
              markup +
              `<li class="voo-cart-drawer__footer-discounts-item">
              <svg aria-hidden="true" width="12" height="12" focusable="false" class="icon icon-discount" viewBox="0 0 12 12">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                </path>
              </svg>
              ${discount.discount_application.title}
              (-<span class="money">${Shopify.formatMoney(discount.amount)}</span>)
              <button class="clear-discount-btn" data-code="${discount.title}"></button>
          </li>`,
            ''
          )}
        </ul>
        `
          : ''
        }
        ${cart.total_discount !== 0
          ? ` <div class="voo-cart-drawer__totals-discount-wrap">
                  <h2 class="voo-cart-drawer__totals-discount-title">${discountAppliedText}</h2>
                  <p class="voo-cart-drawer__totals-discount-value">- ${Shopify.formatMoney(cart.total_discount)}</p>
                </div>`
          : ''
        }
        </div>`
        : ''
      }
        <div class="voo-cart-drawer__sticky-footer">
          <div class="voo-cart-drawer__totals">
            <h2 class="voo-cart-drawer__totals-title">${subtotalText}</h2>
            <p class="voo-cart-drawer__totals-value">${Shopify.formatMoney(cart.total_price)}</p>
          </div>
          <a class="voo-cart-drawer__cta-checkout voo-btn" href="${window.Shopify.routes.root}checkout">
            ${checkoutBtnText} <span class="voo-cart-drawer__cta-checkout-total">&nbsp;- ${Shopify.formatMoney(
        cart.total_price
      )}</span>
          </a>
        </div>
        `;

    cartDrawerFooterEl.innerHTML = cartDrawerFooterInnerMarkup;

    const vooApplyDiscountsEl = document.querySelector('voo-cart-drawer-discount');

    const clearDiscountBtns = cartDrawerFooterEl.querySelectorAll('.clear-discount-btn');

    clearDiscountBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const codeToRemove = btn.dataset.code;
        vooApplyDiscountsEl.removeDiscountCode(codeToRemove);
        vooApplyDiscountsEl.applyDiscount('');
      });
    });


  }
}

customElements.define('voo-cart-drawer', VooCartDrawer);

class VooCartDrawerItems extends HTMLElement {
  constructor() {
    super();

    this.renderCartDrawerItems();
  }

  async renderCartDrawerItems() {
    const cartDrawerItemsEl = document.querySelector('.voo-cart-drawer__items');
    const cart = await getCart();
    const cartItemsMarkup = cart.items.reduce((markup, item, index) => {
      return markup + this.getLineProductMarkup(item, index);
    }, '');

    if (cartDrawerItemsEl) cartDrawerItemsEl.innerHTML = cartItemsMarkup;

    document
      .querySelectorAll('.voo-cart-drawer__item-remove')
      .forEach((btn) => btn.addEventListener('click', this.removeLineProduct.bind(this)));

    document
      .querySelectorAll('[data-change-type]')
      .forEach((btn) => btn.addEventListener('click', this.changeLineProductQuantity.bind(this)));

    document
      .querySelectorAll('.voo-cart-drawer__item-quantity-input')
      .forEach((input) => input.addEventListener('change', this.updateLineQuantity.bind(this)));
  }

  async removeLineProduct(e) {
    const currentProductLineIndex = e.target.closest('.voo-cart-drawer__item')?.dataset.lineIndex;
    await this.updateQuantity(currentProductLineIndex, 0);
  }

  async changeLineProductQuantity(e) {
    const cartDrawerItemEl = e.target.closest('.voo-cart-drawer__item');
    const changeBtnEl = e.target.nodeName === 'BUTTON' ? e.target : e.target.closest('[data-change-type]');

    const currentQuantity = Number(cartDrawerItemEl.querySelector('.voo-cart-drawer__item-quantity-input')?.value);
    const newQuantity = changeBtnEl.dataset.changeType === 'decrease' ? currentQuantity - 1 : currentQuantity + 1;

    await this.updateQuantity(cartDrawerItemEl.dataset.lineIndex, newQuantity);
  }

  async updateLineQuantity(e) {
    const currentProductLineIndex = e.target.closest('.voo-cart-drawer__item')?.dataset.lineIndex;
    const newQuantity = Number(e.target.value);

    await this.updateQuantity(currentProductLineIndex, newQuantity);
  }

  updateLineProductItem(updatedCart, variantId, line) {
    const updatedProduct = updatedCart.items.find((product) => product.variant_id === variantId);
    const currentLineItem = document.querySelector(`[data-line-index="${line}"]`);

    const finalPriceEl = currentLineItem.querySelector('.voo-cart-drawer__item-prices--final');
    const qtyInputEl = currentLineItem.querySelector('.voo-cart-drawer__item-quantity-input');
    const decreaseBtnEl = currentLineItem.querySelector('.voo-cart-drawer__item-decrease');

    if (finalPriceEl) finalPriceEl.innerText = Shopify.formatMoney(updatedProduct.final_line_price);
    if (qtyInputEl) qtyInputEl.value = updatedProduct.quantity;
    if (decreaseBtnEl) decreaseBtnEl.disabled = updatedProduct.quantity === 1 ? true : false;
  }

  async updateQuantity(line, quantity) {
    const currentLineProductVariantId = Number(
      document.querySelector(`[data-line-index="${line}"]`)?.dataset.variantId
    );

    const body = JSON.stringify({
      line,
      quantity,
    });

    const cartChangeRes = await fetch(`${window.Shopify.routes.root}cart/change`, getFetchPostConfig(body));

    const updatedCart = await cartChangeRes.json();
    this.checkIfCartIsEmpty(updatedCart);

    const variantsId = updatedCart.items.map((product) => product.variant_id);
    const uniqueVariantsId = new Set(variantsId);
    const hasItemsWithSameVariantId = variantsId.length !== uniqueVariantsId.size;

    if (quantity === 0 || hasItemsWithSameVariantId) {
      this.renderCartDrawerItems();
    } else {
      this.updateLineProductItem(updatedCart, currentLineProductVariantId, line);
    }

    const cartDrawerEl = document.querySelector('voo-cart-drawer');
    const rewardBarEl = document.querySelector('voo-cart-drawer-reward-bar');
    const freeGiftEl = document.querySelector('voo-cart-drawer-free-gift');
    const bogoEl = document.querySelector('voo-cart-drawer-bogo');
    const recommendationsEl = document.querySelector('voo-cart-drawer-recommendations');

    if (quantity === 0 || line === 1) {
      const recommendationsEl = document.querySelector('voo-cart-drawer-recommendations');

      if (recommendationsEl) recommendationsEl.renderRecommendations();
    }

    if (cartDrawerEl) {
      cartDrawerEl.renderCartDrawerFooter();
      cartDrawerEl.updateStickyBubble(updatedCart.item_count);
      cartDrawerEl.updateHeaderCounter(updatedCart.item_count);
    }

    if (rewardBarEl) rewardBarEl.updateRewardBar();
    if (freeGiftEl) freeGiftEl.updateFreeGiftMessage();
    if (bogoEl) bogoEl.productVariantsToCheckInCartForGift();
    if (recommendationsEl) recommendationsEl.renderRecommendations();
  }

  async checkIfCartIsEmpty(cart) {
    let cartItemsLength;

    if (!cart) {
      const fetchedCart = await getCart();
      cartItemsLength = fetchedCart.items.length;
    } else {
      cartItemsLength = cart.items.length;
    }

    const cartDrawerInnerEl = document.querySelector('.voo-cart-drawer__inner');

    if (cartItemsLength === 0) {
      cartDrawerInnerEl.classList.add('is-empty');
    } else {
      cartDrawerInnerEl.classList.remove('is-empty');
    }
  }

  getLineProductMarkup(lineProduct, index) {
    const productLink = `${location.origin}/products/${lineProduct.handle}`;

    return `
      <li class="voo-cart-drawer__item" data-variant-id="${lineProduct.variant_id}" data-line-key="${lineProduct.key
      }" data-line-index="${index + 1}">
        <div class="voo-cart-drawer__item-content-wrap">
          <div class="voo-cart-drawer__img-wrap">
          <a href="${productLink}" class="voo-cart-drawer__img-link">
              <img
                class="voo-cart-drawer__img"
                src="${lineProduct.image}"
                alt=""
                width="107"
                height="135"
              >
          </a>
        </div>
        <div class="voo-cart-drawer__item-content">
          <div class="voo-cart-drawer__top">
            <div class="voo-cart-drawer__item-name-wrap">
              <h3 class="voo-cart-drawer__item-name">
                <a href="${productLink}" class="voo-cart-drawer__item-name-link voo-link">
                  ${lineProduct.title}
                </a>
              </h3>
              <p class="voo-cart-drawer__item-properties">${lineProduct.variant_title}</p>
              <ul class="voo-cart-drawer__item-properties-list voo-list">
                ${lineProduct.product_has_only_default_variant
        ? ''
        : lineProduct.options_with_values.reduce(
          (markup, option) =>
            markup +
            `<li class="voo-cart-drawer__item-property"><strong>${option.name}</strong>: ${option.value}</li>`,
          ''
        )
      }
              </ul>
              ${lineProduct.line_level_discount_allocations.length > 0
        ? `<span class="voo-cart-drawer__item-discount">
                <ul class="voo-cart-drawer__item-discount-list voo-list">
                  ${lineProduct.line_level_discount_allocations.reduce(
          (markup, discount) =>
            markup + discount.amount > 0
              ? `<li class="voo-cart-drawer__item-discount-name">
                          <svg aria-hidden="true" focusable="false" width="12" height="12" class="icon icon-discount" viewBox="0 0 12 12">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
                          </svg>
                          ${discount.discount_application.title} ${`(-${Shopify.formatMoney(discount.amount)})`}
                        </li >`
              : '',
          ''
        )}
                </ul>
              </span>`
        : ''
      }
            </div>
            <button class="voo-cart-drawer__item-remove voo-btn">
              ${removeLineIcon}
            </button>
          </div>
          <div class="voo-cart-drawer__bottom">
            <div class="voo-cart-drawer__item-quantity">
              <button class="voo-cart-drawer__item-decrease voo-btn" ${lineProduct.quantity === 1 ? 'disabled' : ''
      } data-change-type="decrease">
                ${minusIcon}
              </button>
              <input class="voo-cart-drawer__item-quantity-input" type="text" value="${lineProduct.quantity}">
              <button class="voo-cart-drawer__item-increase voo-btn" data-change-type="increase">
                ${plusIcon}
              </button>
            </div>
            <div class="voo-cart-drawer__item-prices-wrap">
              <span class="voo-cart-drawer__item-prices--original">
                ${lineProduct.original_line_price === lineProduct.final_line_price
        ? ''
        : Shopify.formatMoney(lineProduct.original_line_price)
      }
              </span>
              <span class="voo-cart-drawer__item-prices--final">${Shopify.formatMoney(
        lineProduct.final_line_price
      )}</span>
            </div>
          </div>
        </div>
        </div>
      </li>
    `;
  }
}

// Subscribe & Save 20%
// <div class="voo-cart-drawer__item-subscribe-wrap">
//   <button class="voo-cart-drawer__item-subscribe-btn" type="button" data-selling-plan="${''}">Subscribe & Save 20%</button>
//   <button class="voo-cart-drawer__item-subscribe-info" type="button"></button>
// </div>
customElements.define('voo-cart-drawer-items', VooCartDrawerItems);

class VooCartNote extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const noteTextareaEl = this.querySelector('.voo-cart-drawer__note-textarea');
    this.addTriggerListener();
    this.renderCurrentCartNote();

    if (noteTextareaEl) {
      noteTextareaEl.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${window.Shopify.routes.root}cart/update`, getFetchPostConfig(body));
        }, 300)
      );
    }
  }

  async renderCurrentCartNote() {
    const textareaEl = this.querySelector('.voo-cart-drawer__note-textarea');

    if (!textareaEl) return;

    const cart = await getCart();
    textareaEl.value = cart.note;
  }

  addTriggerListener() {
    const noteTriggerEl = this.querySelector('.voo-cart-drawer__note-trigger');

    if (!noteTriggerEl) return;

    const cartNoteEl = this.querySelector('.voo-cart-drawer__note-textarea');
    const triggerCartNote = () => {
      if (cartNoteEl.classList.contains('voo-hidden')) {
        cartNoteEl.classList.remove('voo-hidden');
        return;
      }

      cartNoteEl.classList.add('voo-hidden');
    };

    noteTriggerEl.addEventListener('click', triggerCartNote);
  }
}

customElements.define('voo-cart-note', VooCartNote);

class VooCartDrawerAnnouncement extends HTMLElement {
  constructor() {
    super();

    this.initSiemaSlider();
  }

  initSiemaSlider() {
    let intervalId;

    if (typeof Siema == 'undefined') {
      this.style.display = 'none';
      return;
    }

    const announcementSlider = new Siema({
      selector: '.siema.voo-cart-drawer__announcement-list',
      loop: true,
    });

    if (this.dataset.autoplay) intervalId = setInterval(() => announcementSlider.next(), 3000);

    const hideControls = announcementSlider.innerElements.length < 2;

    const onAnnouncementSliderControlsClick = (e) => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = '';
      }

      if (e.currentTarget.classList.contains('prev')) {
        announcementSlider.prev();
      } else {
        announcementSlider.next();
      }
    };

    this.querySelectorAll('.voo-cart-drawer__announcement-btn').forEach((btn) => {
      if (hideControls) btn.style.display = 'none';

      btn.addEventListener('click', onAnnouncementSliderControlsClick);
    });
    this.setTimer();

    const elemsToBeCopied = this.querySelectorAll('strong');
    const validElemsToBeCopied = [...elemsToBeCopied].filter((el) => !el.classList.contains('expiration-time'));

    validElemsToBeCopied.forEach((code) =>
      code.insertAdjacentHTML(
        'afterbegin',
        '<span class="voo-cart-drawer__announcement-copy-msg">Copy to clipboard</span>'
      )
    );

    const copyCode = (event) => {
      const copyMsgEl = event.target.querySelector('.voo-cart-drawer__announcement-copy-msg');
      navigator.clipboard.writeText(event.target.childNodes[1].textContent);

      if (copyMsgEl) copyMsgEl.innerText = 'Copied';
    };

    const onMouseEnter = (event) => {
      const copyMsgEl = event.target.querySelector('.voo-cart-drawer__announcement-copy-msg');

      if (copyMsgEl) copyMsgEl.innerText = 'Copy to clipboard';
    };

    validElemsToBeCopied.forEach((boldEl) => {
      boldEl.addEventListener('click', copyCode);
      boldEl.addEventListener('mouseenter', onMouseEnter);
    });
  }

  setTimer() {
    const sliderStrongTags = this.querySelectorAll('strong');
    const timerEl = [...sliderStrongTags].find((tag) => tag.innerHTML.includes('{timer'));

    if (!timerEl) return;

    timerEl.classList.add('expiration-time');

    const timerInnerText = timerEl.innerHTML.slice(1, -1);
    const [timerPlug, minutesToCountDown] = timerInnerText.split(':');
    const secondsToCountDown = '00';

    const startDateTimestamp = new Date().getTime();
    const timeDifferenceInMilliseconds = (Number(secondsToCountDown) + Number(minutesToCountDown) * 60) * 1000;
    const timestampToCreateEndDate = startDateTimestamp + timeDifferenceInMilliseconds;
    const finishDate = new Date(timestampToCreateEndDate);

    const timerInterval = setInterval(function () {
      const now = new Date().getTime();
      const distance = Math.round((finishDate - now) / 1000) * 1000;

      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      timerEl.innerText = (minutes > 9 ? minutes : `0${minutes}`) + ':' + (seconds > 9 ? seconds : `0${seconds}`);

      if (distance < 0) {
        clearInterval(timerInterval);
        timerEl.innerText = '00:00';
      }
    }, 1000);
  }
}

customElements.define('voo-cart-drawer-announcement', VooCartDrawerAnnouncement);

class vooCartDrawerFreeGift extends HTMLElement {
  constructor() {
    super();

    this.fillWithVariantData();
  }

  async getProductVariantData(variantId) {
    try {
      const res = await fetch(`${window.Shopify.routes.root}variants/${variantId}.js`);

      if (!res.ok) {
        throw new Error('HTTP error: ', res.status);
      }

      return await res.json();
    } catch (error) {
      console.error(error.message);
    }
  }

  async fillWithVariantData() {
    const { productVariantId, targetTotal } = VOOCART.config.blocks.freeGift.settings;
    const giftVariantData = await this.getProductVariantData(productVariantId);

    const giftImageEl = this.querySelector('.voo-cart-drawer__gift-img');
    const giftNameEl = this.querySelector('.voo-cart-drawer__gift-name');
    const giftTotalLeftEl = this.querySelector('.voo-cart-drawer__gift-total-left');

    if (giftImageEl) {
      if (VOOCART.config.blocks.freeGift.settings.customImage) {
        giftImageEl.src = VOOCART.config.blocks.freeGift.settings.customImage;
      } else {
        giftImageEl.src = giftVariantData.featured_image?.src;
      }
      giftImageEl.alt = giftVariantData.name;
    }

    if (giftNameEl) giftNameEl.innerText = giftVariantData.name;

    if (giftTotalLeftEl) giftTotalLeftEl.innerText = Shopify.formatMoney(targetTotal * 100);

    this.updateFreeGiftMessage();
  }

  async addGiftProductToCart() {
    const { productVariantId } = VOOCART.config.blocks.freeGift.settings;
    const cart = await getCart();
    const giftProductIndexCartIndex = cart.items.findIndex(
      (lineProductItem) => lineProductItem.variant_id === productVariantId
    );
    const cartDrawerEl = document.querySelector('voo-cart-drawer');

    if (giftProductIndexCartIndex === -1 && cartDrawerEl) {
      await cartDrawerEl.addProducts([{ id: productVariantId, quantity: 1 }]);
    }
  }

  async removeGiftProductFromCart() {
    const { productVariantId } = VOOCART.config.blocks.freeGift.settings;
    const cart = await getCart();
    const giftProductIndexCartIndex = cart.items.findIndex(
      (lineProductItem) => lineProductItem.variant_id === productVariantId
    );
    const cartDrawerEl = document.querySelector('voo-cart-drawer');

    if (giftProductIndexCartIndex !== -1 && cartDrawerEl) {
      await cartDrawerEl.removeProducts([{ id: productVariantId, quantity: 1 }]);
    }
  }

  async updateFreeGiftMessage() {
    const { targetTotal, productVariantId } = VOOCART.config.blocks.freeGift.settings;
    const cartDrawerEl = document.querySelector('voo-cart-drawer');
    const totalLeftToGetGiftEl = this.querySelector('.voo-cart-drawer__gift-total-left');
    const freeGiftWrapperEl = this.querySelector('.voo-cart-drawer__gift-message-wrapper');

    const cart = await getCart();
    const giftProductInCart = cart.items.find((cartLineItem) => cartLineItem.variant_id === productVariantId);

    const giftProductLineTotal = giftProductInCart ? giftProductInCart.line_price / 100 : 0;

    const currentCartTotal = cart.total_price / 100;
    const totalLeftToGetGift = targetTotal - currentCartTotal + giftProductLineTotal;

    if (totalLeftToGetGift <= 0) {
      freeGiftWrapperEl.style.display = 'none';
      await this.addGiftProductToCart();
      cartDrawerEl.renderCartDrawerItems();
      return;
    } else {
      await this.removeGiftProductFromCart();
    }

    if (VOOCART.config.blocks.freeGift.settings.hiddenBlock) {
      freeGiftWrapperEl.classList.add('hidden');
    }

    cartDrawerEl.renderCartDrawerItems();
    freeGiftWrapperEl.style.display = 'flex';

    if (totalLeftToGetGiftEl) totalLeftToGetGiftEl.innerText = Shopify.formatMoney(totalLeftToGetGift * 100);
  }
}

customElements.define('voo-cart-drawer-free-gift', vooCartDrawerFreeGift);

class VooCartDrawerQuickBuy extends HTMLElement {
  constructor() {
    super();

    this.initGallerySlider();
  }

  initGallerySlider() {
    const galleryListEl = this.querySelector('.voo-cart-drawer__quick-buy-gallery-list');

    if (typeof Flickity == 'undefined') {
      return;
    }

    const gallerySlider = new Flickity(galleryListEl, {
      lazyLoad: 2,
      draggable: true,
      prevNextButtons: false,
      cellAlign: 'left',
      pageDots: false,
      autoPlay: true,
      wrapAround: true,
      dragThreshold: 30,
      autoPlay: 3500,
      imagesLoaded: true,
    });

    gallerySlider.resize();
  }
}

customElements.define('voo-cart-drawer-quick-buy', VooCartDrawerQuickBuy);

class VooCartDrawerRecommendations extends HTMLElement {
  constructor() {
    super();

    this.renderRecommendations();
  }

  recommendationProductsData = [];
  productsWithDifferentColorsData = [];

  addEventListenersForAddBtns() {
    const addRecommendationProductBtnElems = document.querySelectorAll(
      '.voo-cart-drawer__recommendations-qiuck-buy-btn'
    );
    addRecommendationProductBtnElems.forEach((btn) => btn.addEventListener('click', this.addProductToCart.bind(this)));
  }

  initRecommendationSlider() {
    const { navMode, navModeMob } = VOOCART.config.blocks.recommendations.settings;
    const isMobile = window.innerWidth < 768;
    const sliderNavigationMode = isMobile ? navModeMob : navMode;

    if (!(sliderNavigationMode === 'slider')) return;

    const recommendationsListEl = this.querySelector('.voo-cart-drawer__recommendations-list');
    const prevBtnEl = this.querySelector('.voo-cart-drawer__recommendations-controls-btn.prev');
    const nextBtnEl = this.querySelector('.voo-cart-drawer__recommendations-controls-btn.next');

    const recommendationSlider = new Flickity(recommendationsListEl, {
      lazyLoad: 2,
      draggable: true,
      prevNextButtons: false,
      cellAlign: 'left',
      pageDots: false,
      autoPlay: true,
      wrapAround: true,
      dragThreshold: 30,
      adaptiveHeight: false,
      autoPlay: 3500,
      imagesLoaded: true,
    });
    recommendationSlider.resize();

    if (prevBtnEl)
      prevBtnEl.addEventListener('click', function () {
        recommendationSlider.previous();
        recommendationSlider.stopPlayer();
      });

    if (nextBtnEl)
      nextBtnEl.addEventListener('click', function () {
        recommendationSlider.next();
        recommendationSlider.stopPlayer();
      });

    const hideControls = recommendationSlider.slides.length < 2;

    this.querySelectorAll('.voo-cart-drawer__recommendations-controls-btn').forEach((btn) => {
      if (hideControls) {
        btn.style.display = 'none';
      } else {
        btn.style.display = 'flex';
      }
    });
  }

  getProductVariantData(productId, variantId) {
    const productData = this.recommendationProductsData.find((product) => product.id === productId);
    return productData.variants.find((variant) => variant.id === variantId);
  }

  addQuickBuyClickListeners() {
    const quickBuyBtnElems = this.querySelectorAll('.voo-cart-drawer__recommendations-qiuck-buy-btn');
    quickBuyBtnElems.forEach((btn) => btn.addEventListener('click', this.onQuickBuyClick.bind(this)));
  }

  async onQuickBuyClick(e) {
    const recommendationProductHandle = e.target.closest('.voo-cart-drawer__recommendations-item')?.dataset
      .productHandle;

    if (!recommendationProductHandle) return;

    const productData = this.recommendationProductsData.find(
      (product) => product.handle === recommendationProductHandle
    );
    const quickBuySkeletonMarkup = this.getQuickBuyDrawerSkeletonMarkup();
    document.querySelector('.voo-cart-drawer__quick-buy-product-info-wrap').innerHTML = quickBuySkeletonMarkup;
    document.querySelector('.voo-cart-drawer__quick-buy-drawer').classList.add('open');

    await this.updateQuickBuyProductMarkup(productData);
    this.disableNotAvailableOptions(productData);
  }

  addVariantChangeListeners() {
    const variantBtnElems = document.querySelectorAll('.voo-cart-drawer__quick-buy-variants-list');
    variantBtnElems.forEach((btn) => btn.addEventListener('click', this.onVariantChange.bind(this)));
  }

  onVariantChange(e) {
    if (e.target.nodeName !== 'BUTTON') return;

    const selectEl = e.target.closest('[data-option-select-name]');
    const selectValueEl = selectEl.querySelector('.voo-cart-drawer__quick-buy-variant-value');

    if (!selectEl) return;

    const chosenValue = e.target.dataset.variantValue;
    selectEl.dataset.optionSelectValue = chosenValue;
    if (selectValueEl) selectValueEl.innerText = chosenValue;

    const currentSelectorVariantBtnElems = selectEl.querySelectorAll('.voo-cart-drawer__quick-buy-variants-btn');
    currentSelectorVariantBtnElems.forEach((btn) => btn.classList.remove('active'));
    e.target.classList.add('active');

    const chosenVariant = this.findCurrentVariant();
    this.updateVariantDynamicContent(chosenVariant);
    this.checkDisabledOptions(selectEl.dataset.optionSelectName);
  }

  updateVariantDynamicContent(newVariantData) {
    const priceEl = document.querySelector('.voo-cart-drawer__quick-buy-original');
    const addBtnPriceEl = document.querySelector('.voo-cart-drawer__quick-buy-add-btn-cost');

    if (priceEl) priceEl.innerText = Shopify.formatMoney(newVariantData.price);
    if (addBtnPriceEl) addBtnPriceEl.innerText = Shopify.formatMoney(newVariantData.price);
  }

  getCurrentProductData(productId) {
    const productFromRecommendationsData = this.recommendationProductsData.find((product) => productId === product.id);
    if (productFromRecommendationsData) return productFromRecommendationsData;

    const productFromProductWithColorsData = this.productsWithDifferentColorsData.find(
      (productObj) => productId === productObj.product.id
    );
    return productFromProductWithColorsData.product;
  }

  disableNotAvailableOptions(productData, targetSelectName = 'defaultOption1') {
    const unavailableVariants = productData.variants.filter((variant) => !variant.available);

    if (productData.options.length === 1) {
      unavailableVariants.forEach((unavailableVariant) => {
        const unavailableVariantOptionEl = document.querySelector(
          `[data-variant-value="${unavailableVariant.option1}"]`
        );
        unavailableVariantOptionEl.disabled = true;
      });
    }

    const checkIfOption1ValueHasAvailableVariant = (variants, optionValue) => {
      return variants.find((variant) => variant.option1 === optionValue && variant.available);
    };

    // TO DO productData.options.length === 3 case
    if (productData.options.length === 2) {
      const firstSelectEl = document.querySelector('[data-option-select-name="option1"]');
      const secondSelectEl = document.querySelector('[data-option-select-name="option2"]');
      const option1ChosenValue = firstSelectEl?.dataset.optionSelectValue;
      const option2ChosenValue = secondSelectEl?.dataset.optionSelectValue;

      if (targetSelectName === 'defaultOption1' || targetSelectName === 'option1') {
        const unavailableVariantsWithCurrentOption1Value = unavailableVariants.filter(
          (unavailableVariant) => unavailableVariant.option1 === option1ChosenValue
        );

        const activeOptionEl = secondSelectEl.querySelector('.voo-cart-drawer__quick-buy-variants-btn.active');
        const variantWithCurrentOption2IsAvailable = productData.variants.find(
          (variant) =>
            variant.available &&
            variant.option2 === activeOptionEl.dataset.variantValue &&
            variant.option1 === option1ChosenValue
        );

        if (!variantWithCurrentOption2IsAvailable) {
          activeOptionEl.classList.remove('active');

          const firstAvailableVariantWithCurrentOption1Value = productData.variants.find(
            (variant) => variant.option1 === option1ChosenValue && variant.available
          );
          const availableVariantOption2El = secondSelectEl.querySelector(
            `[data-variant-value="${firstAvailableVariantWithCurrentOption1Value.option2}"]`
          );

          availableVariantOption2El.classList.add('active');
        }

        const option1ValueHasAvailableVariant = checkIfOption1ValueHasAvailableVariant(
          productData.variants,
          option1ChosenValue
        );

        if (targetSelectName === 'defaultOption1') {
          const option1BtnElems = document.querySelectorAll('.voo-cart-drawer__quick-buy-variants-btn:not(.active)');
          option1BtnElems.forEach((btn) => {
            const optionValue = btn.dataset.variantValue;
            if (!checkIfOption1ValueHasAvailableVariant(productData.variants, optionValue)) btn.disabled = true;
          });
        }

        const disabledOptionElems = secondSelectEl.querySelectorAll(
          '.voo-cart-drawer__quick-buy-variants-btn[disabled]'
        );
        disabledOptionElems.forEach((btn) => (btn.disabled = false));

        unavailableVariantsWithCurrentOption1Value.forEach((unavailableVariant) => {
          const unavailableVariantOptionEl = secondSelectEl.querySelector(
            `[data-variant-value="${unavailableVariant.option2}"]`
          );
          unavailableVariantOptionEl.disabled = true;
        });
      }

      if (targetSelectName === 'option2') {
        const unavailableVariantsWithCurrentOption2Value = unavailableVariants.filter(
          (unavailableVariant) => unavailableVariant.option2 === option2ChosenValue
        );

        const activeOptionEl = firstSelectEl.querySelector('.voo-cart-drawer__quick-buy-variants-btn.active');
        const variantWithCurrentOption1IsAvailable = productData.variants.find(
          (variant) =>
            variant.available &&
            variant.option1 === activeOptionEl.dataset.variantValue &&
            variant.option2 === option2ChosenValue
        );

        if (!variantWithCurrentOption1IsAvailable) {
          activeOptionEl.remove('active');

          const firstAvailableVariantWithCurrentOption2Value = productData.variants.find(
            (variant) => variant.option2 === option2ChosenValue && variant.available
          );
          const availableVariantOption1El = firstSelectEl.querySelector(
            `[data-variant-value="${firstAvailableVariantWithCurrentOption2Value.option1}"]`
          );

          availableVariantOption1El.classList.add('active');
        }

        const disabledOptionElems = firstSelectEl.querySelectorAll(
          '.voo-cart-drawer__quick-buy-variants-btn[disabled]'
        );
        disabledOptionElems.forEach((btn) => (btn.disabled = false));

        unavailableVariantsWithCurrentOption2Value.forEach((unavailableVariant) => {
          const unavailableVariantOptionEl = secondSelectEl.querySelector(
            `[data-variant-value="${unavailableVariant.option1}"]`
          );
          unavailableVariantOptionEl.disabled = true;
        });
      }
    }
  }

  checkDisabledOptions(targetSelectName) {
    const firstSelect = document.querySelector('[data-option-select-name="option1"]');
    const secondSelect = document.querySelector('[data-option-select-name="option2"]');
    const thirdSelect = document.querySelector('[data-option-select-name="option3"]');

    if (firstSelect && !secondSelect && !thirdSelect) return;

    const productId = Number(document.querySelector('[data-chosen-product-id]')?.dataset.chosenProductId);
    const productData = this.getCurrentProductData(productId);

    // TO DO firstSelect && secondSelect && thirdSelect case
    if (firstSelect && secondSelect && !thirdSelect) this.disableNotAvailableOptions(productData, targetSelectName);
  }

  findCurrentVariant(color) {
    const currentColorHexValue = color
      ? color
      : document.querySelector('.voo-cart-drawer__quick-buy-colors-swatch.active')?.dataset.colorHexValue;
    const isColorPicker = document.querySelector('.voo-cart-drawer__quick-buy-colors-list');

    if (!currentColorHexValue && isColorPicker) {
      return;
    }

    let chosenProductData;
    const variantSelectsWithValues = {};

    if (isColorPicker) {
      const chosenColorProductObj = this.productsWithDifferentColorsData.find(
        (productObj) => productObj.color === currentColorHexValue
      );

      chosenProductData = chosenColorProductObj.product;
    } else {
      const chosenProductId = Number(document.querySelector('[data-chosen-product-id]')?.dataset.chosenProductId);
      chosenProductData = this.recommendationProductsData.find((product) => product.id === chosenProductId);
    }

    chosenProductData.options.forEach((option, index) => {
      const optionName = 'option' + (index + 1);
      const optionSelectorEl = document.querySelector(`[data-option-select-name="${optionName}"]`);

      if (!optionSelectorEl) return;

      const optionSelectorChosenValue = optionSelectorEl.dataset.optionSelectValue;
      variantSelectsWithValues[optionName] = optionSelectorChosenValue ? optionSelectorChosenValue : null;
    });

    return chosenProductData.variants.find((variant) => {
      switch (variant.options.length) {
        case 1:
          return variant.option1 === variantSelectsWithValues.option1;
        case 2:
          return (
            variant.option1 === variantSelectsWithValues.option1 && variant.option2 === variantSelectsWithValues.option2
          );
        case 3:
          return (
            variant.option1 === variantSelectsWithValues.option1 &&
            variant.option2 === variantSelectsWithValues.option2 &&
            variant.option3 === variantSelectsWithValues.option3
          );
        default:
          return;
      }
    });
  }

  getQuickBuyDrawerMarkup() {
    return `
        <div class="voo-cart-drawer__quick-buy-drawer">
          <div class="voo-cart-drawer__quick-buy-back-btn-wrap">
            <button class="voo-cart-drawer__quick-buy-back-btn" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                <path d="M1.63136 5.45007H12.9348C13.0847 5.45007 13.2285 5.50801 13.3345 5.61114C13.4405 5.71427 13.5 5.85415 13.5 6C13.5 6.14585 13.4405 6.28573 13.3345 6.38886C13.2285 6.49199 13.0847 6.54993 12.9348 6.54993H1.63136C1.48146 6.54993 1.33771 6.49199 1.23172 6.38886C1.12573 6.28573 1.06618 6.14585 1.06618 6C1.06618 5.85415 1.12573 5.71427 1.23172 5.61114C1.33771 5.50801 1.48146 5.45007 1.63136 5.45007Z" fill="currentColor"/>
                <path d="M1.86534 6L6.55289 10.56C6.65901 10.6633 6.71863 10.8033 6.71863 10.9494C6.71863 11.0954 6.65901 11.2355 6.55289 11.3387C6.44676 11.442 6.30283 11.5 6.15274 11.5C6.00266 11.5 5.85873 11.442 5.7526 11.3387L0.666041 6.38935C0.613408 6.33827 0.57165 6.27758 0.543158 6.21077C0.514666 6.14396 0.5 6.07233 0.5 6C0.5 5.92767 0.514666 5.85604 0.543158 5.78923C0.57165 5.72242 0.613408 5.66173 0.666041 5.61065L5.7526 0.661274C5.85873 0.558012 6.00266 0.5 6.15274 0.5C6.30283 0.5 6.44676 0.558012 6.55289 0.661274C6.65901 0.764537 6.71863 0.90459 6.71863 1.05063C6.71863 1.19666 6.65901 1.33671 6.55289 1.43998L1.86534 6Z" fill="currentColor"/>
              </svg>
              ${'Back to cart'}
            </button>
          </div>
          <div class="voo-cart-drawer__quick-buy-product-info-wrap"></div>
        </div>
     `;
  }

  getQuickBuyDrawerSkeletonMarkup() {
    return `
        <div class="voo-cart-drawer__quick-buy--skeleton pulsate">
          <div>
            <div class="voo-cart-drawer__quick-buy-gallery--skeleton"></div>
            <div class="voo-cart-drawer__quick-buy-title--skeleton"></div>
            <div class="voo-cart-drawer__quick-buy-prices--skeleton"></div>
            <div class="voo-cart-drawer__quick-buy-variants-title--skeleton"></div>
            <div class="voo-cart-drawer__quick-buy-variants-colors--skeleton">
              <div class="voo-cart-drawer__quick-buy-color--skeleton"></div>
              <div class="voo-cart-drawer__quick-buy-color--skeleton"></div>
              <div class="voo-cart-drawer__quick-buy-color--skeleton"></div>
            </div>
            <div class="voo-cart-drawer__quick-buy-variants-title--skeleton"></div>
            <div class="voo-cart-drawer__quick-buy-variants-sizes--skeleton">
              <div class="voo-cart-drawer__quick-buy-size--skeleton"></div>
              <div class="voo-cart-drawer__quick-buy-size--skeleton"></div>
              <div class="voo-cart-drawer__quick-buy-size--skeleton"></div>
              <div class="voo-cart-drawer__quick-buy-size--skeleton"></div>
            </div>
          </div>
          <div>
            <div class="voo-cart-drawer__quick-buy-button--skeleton"></div>
            <div class="voo-cart-drawer__quick-buy-details--skeleton"></div>
          </div>
        </div>
     `;
  }

  async updateQuickBuyProductMarkup(productData) {
    const quickBuyProductInfoEl = document.querySelector('.voo-cart-drawer__quick-buy-product-info-wrap');
    const productInfoMarkup = await this.getProductInfoMarkup(productData);

    quickBuyProductInfoEl.innerHTML = productInfoMarkup;

    this.addVariantChangeListeners();
    this.addEventListenersForAddBtns();
  }

  findFirstAvailableVariant(productData) {
    return productData.variants.find((variant) => variant.available);
  }

  async getProductInfoMarkup(productObj) {
    const productData = productObj;
    const productLink = `${location.origin}/products/${productData.handle}`;

    const isMobile = window.innerWidth < 768;

    const chosenVariant = this.findFirstAvailableVariant(productObj);

    return `
     <div class="voo-cart-drawer__quick-buy-product-info" data-chosen-product-id="${productData.id}">
        <div>${isMobile
        ? ''
        : `<voo-cart-drawer-quick-buy>
            <ul class="voo-cart-drawer__quick-buy-gallery-list list-unstyled">
              ${productData.images.reduce(
          (markup, image) =>
            markup +
            `
                  <li class="voo-cart-drawer__quick-buy-gallery-item">
                    <img class="voo-cart-drawer__quick-buy-gallery-img" src="${image}" alt="${productData.title}" width="296" height="395"/>
                  </li>
                `,
          ''
        )}
            </ul>
            </voo-cart-drawer-quick-buy>`
      }
            <div class="voo-cart-drawer__quick-buy-info">
              <div class="voo-cart-drawer__quick-buy-img-with-title">
                ${isMobile
        ? `<img class="voo-cart-drawer__quick-buy-gallery-img" src="${productData.images[0]}" alt="${productData.title}" width="164" height="219"/>`
        : ''
      }
                <div>
                  <h3 class="voo-cart-drawer__quick-buy-title">${productData.title}</h3>
                  <div class="voo-cart-drawer__quick-buy-prices">
                    <span class="money voo-cart-drawer__quick-buy-original">${Shopify.formatMoney(
        chosenVariant.price
      )}</span>
                    ${chosenVariant.compare_at_price
        ? `<span class="voo-cart-drawer__quick-buy-compare-at money">${Shopify.formatMoney(
          chosenVariant.compare_at_price
        )}</span>`
        : ''
      }
                  </div>
                </div>
              </div>

              <div class="voo-cart-drawer__quick-buy-variants-wrap">
                ${productData.options.reduce((markup, option, index) => {
        const optionName = 'option' + (index + 1);
        return (
          markup +
          `<div class="voo-cart-drawer__quick-buy-variants" data-option-select-name="${optionName}" data-option-select-value="${chosenVariant[optionName]
          }">
                      <p class="voo-cart-drawer__quick-buy-variants-title">
                        ${option.name ? option.name : option}:
                        <span class="voo-cart-drawer__quick-buy-variant-value">
                        ${chosenVariant[optionName]}</span>
                      </p>
                      <ul class="voo-cart-drawer__quick-buy-variants-list list-unstyled">
                        ${option.values.reduce(
            (markup, optionValue, index) =>
              markup +
              `
                            <li class="voo-cart-drawer__quick-buy-variants-item">
                              <button class="voo-cart-drawer__quick-buy-variants-btn ${chosenVariant[optionName] === optionValue ? 'active' : ''
              }" type="button" data-variant-value="${optionValue}">${optionValue}</button>
                            </li>
                          `,
            ''
          )}
                      </ul>
                    </div>`
        );
      }, '')}
              </div>
            </div>
            </div>
            <div class="voo-cart-drawer__quick-buy-footer">
              <button class="voo-cart-drawer__btn voo-cart-drawer__quick-buy-add-btn" type="button">
                ${'Add to cart -'}
                <span class="voo-cart-drawer__quick-buy-add-btn-cost">
                  &nbsp;${Shopify.formatMoney(chosenVariant.price)}
                </span>
              </button>
              <a class="voo-cart-drawer__quick-buy-details-link" href="${productLink}">${'View all details'}</a>
            </div>
          </div>`;
  }

  createRecommendationMarkup(product) {
    const { addBtnText } = VOOCART.config.blocks.recommendations.settings;
    const productLink = `${location.origin}/products/${product.handle}`;
    const productImage = product.featured_image
      ? product.featured_image
      : product.media
        ? product.media[0].preview_image.src
        : '//voodoo-dev-store.com/cdn/shop/products/AAUvwnj0ICORVuxs41ODOvnhvedArLiSV20df7r8XBjEUQ_s900-c-k-c0x00ffffff-no-rj_ca8a6d1d-8fd6-4ac4-afcf-ab7f62dd92b4.jpg?v=1670516969&width=1946';
    const firstAvailableVariant = product.variants.find((variant) => variant.available === true);
    if (!firstAvailableVariant) return '';

    return `<li class="voo-cart-drawer__recommendations-item" data-product-id=${product.id} data-variant-id=${firstAvailableVariant.id} data-product-handle=${product.handle}>
        <div class="voo-cart-drawer__recommendations-info">
          <div class="voo-cart-drawer__recommendations-img-wrap">
            <a class="voo-cart-drawer__recommendations-img-link" href="${productLink}">
              <img
                class="voo-cart-drawer__recommendations-img"
                src="${productImage}"
                alt="${product.title}"
                loading="lazy"
                width="86"
                height="115"
              >
            </a>
          </div>
          <div class="voo-cart-drawer__recommendations-text">
              <a href="${productLink}" class="voo-link">
                <h4 class="voo-cart-drawer__recommendations-name">${product.title}</h4>
              </a>
              <div class="voo-cart-drawer__recommendations-prices">
                <span class="money voo-cart-drawer__recommendations-original">${Shopify.formatMoney(
      product.variants[0].price
    )}</span>
                ${product.variants[0].compare_at_price
        ? `<span class="voo-cart-drawer__recommendations-compare-at money">${Shopify.formatMoney(
          product.variants[0].compare_at_price
        )}</span>`
        : ''
      }
              </div>
          </div>
        </div>
        <div class="voo-cart-drawer__recommendations-add">
          <button class="voo-btn voo-cart-drawer__recommendations-qiuck-buy-btn">
            ${addBtnText ? addBtnText : 'Add'}
            <div class="voo-cart-drawer__recommendations-qiuck-buy-btn-icon">${plusWithNoSpaceIcon}</div>
          </button>
        </div>
      </li>`;
  }

  async addProductToCart(e) {
    const { addBtnLoadingText } = VOOCART.config.blocks.recommendations.settings;
    const targetAddBtn = e.target;
    const targetAddBtnInnerContent = e.target.innerHTML;
    // const recommendationProductVariant = this.findCurrentVariant().id;
    const recommendationProductVariant = Number(
      e.target.closest('.voo-cart-drawer__recommendations-item')?.dataset.variantId
    );

    const addBtnElems = document.querySelectorAll('.voo-cart-drawer__recommendations-qiuck-buy-btn');
    addBtnElems.forEach((btn) => (btn.disabled = true));

    const body = JSON.stringify({
      items: [
        {
          id: recommendationProductVariant,
          quantity: 1,
        },
      ],
    });

    try {
      targetAddBtn.innerText = addBtnLoadingText;
      targetAddBtn.disabled = true;
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', getFetchPostConfig(body));

      if (!res.ok) return;

      const vooCartDrawerEl = document.querySelector('voo-cart-drawer');
      await vooCartDrawerEl.renderDynamicContent();

      targetAddBtn.innerHTML = targetAddBtnInnerContent;

      const quickBuyDrawerEl = document.querySelector('.voo-cart-drawer__quick-buy-drawer');
      quickBuyDrawerEl.classList.remove('open');

      await this.renderRecommendations();
    } catch (error) {
      targetAddBtn.innerHTML = targetAddBtnInnerContent;
      targetAddBtn.disabled = false;
      console.error('Error:', error);
    } finally {
      addBtnElems.forEach((btn) => (btn.disabled = false));
    }
  }

  async getRecommendations(productId, limit = 4) {
    const res = await fetch(
      `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}`
    );
    const recommendationsData = await res.json();
    return recommendationsData;
  }

  async renderRecommendations() {
    const cart = await getCart();
    const recommendationsListEl = this.querySelector('.voo-cart-drawer__recommendations-list');

    let counter = 0;
    const { productList, useRecommendationsApi, limit } = VOOCART.config.blocks.recommendations.settings;

    if (useRecommendationsApi) {
      const firstProductId = cart.items[0]?.product_id;
      if (!firstProductId) return;

      const recommendationsData = await this.getRecommendations(firstProductId, limit);
      this.recommendationProductsData = recommendationsData.products;
    } else {
      this.recommendationProductsData = productList;
    }

    const recommendationMarkup = this.recommendationProductsData.reduce((markup, product) => {
      if (counter > limit - 1) return markup;
      if (cart.items.find((cartProduct) => product.id === cartProduct.product_id)) return markup;

      counter += 1;
      return (markup += this.createRecommendationMarkup(product));
    }, '');

    const newRecommendationList = document.createElement('ul');
    newRecommendationList.classList.add('voo-cart-drawer__recommendations-list', 'voo-list');
    newRecommendationList.innerHTML = recommendationMarkup;

    if (recommendationsListEl) recommendationsListEl.replaceWith(newRecommendationList);

    this.style.display = recommendationMarkup ? 'block' : 'none';
    // this.addQuickBuyClickListeners();
    this.addEventListenersForAddBtns();
    this.initRecommendationSlider();
  }
}

customElements.define('voo-cart-drawer-recommendations', VooCartDrawerRecommendations);

class VooCartDrawerRewardBar extends HTMLElement {
  constructor() {
    super();

    this.getRewardsMarkup();
    this.updateRewardBar();
  }

  updateRewardBar() {
    this.renderProgressMessages();
    this.updateProgressLine();
  }

  getLastReward() {
    const sortedRewards = VOOCART.config.blocks.rewardBar.settings.rewards.sort(this.sortByTargetTotal);

    return sortedRewards[sortedRewards.length - 1];
  }

  async getPercentageOfProgressLineFill(cartTotal) {
    let currentCartTotal = cartTotal;
    if (!cartTotal) {
      const cart = await getCart();
      currentCartTotal = cart.total_price / 100;
    }
    const lastRewardTargetTotal = Number(this.getLastReward().targetTotal);
    return (((currentCartTotal / 100) * 100) / lastRewardTargetTotal) * 100;
  }

  async updateProgressLine() {
    const progressLineEl = this.querySelector('.voo-cart-drawer__reward-bar-line');
    const percentage = await this.getPercentageOfProgressLineFill();

    if (progressLineEl) progressLineEl.style.background = this.getGradientForProgressLine(percentage);
  }

  getGradientForProgressLine(percentage) {
    return `linear-gradient(to right, #AA2A56 ${percentage}%, transparent ${percentage}%)`;
  }

  async countTotalLeftToGetDiscount() {
    const cart = await getCart();
    const totalPriceLeftToGetDiscount = this.totalToGetDiscount - cart.total_price / 100;

    return {
      amount: totalPriceLeftToGetDiscount,
      fullPercentage: (cart.total_price / 100 / this.totalToGetDiscount) * 100,
    };
  }

  sortByTargetTotal(a, b) {
    const targetTotalA = Number(a.targetTotal);
    const targetTotalB = Number(b.targetTotal);

    if (targetTotalA > targetTotalB) {
      return 1;
    }

    if (targetTotalA < targetTotalB) {
      return -1;
    }

    return 0;
  }

  async renderProgressMessages() {
    const cart = await getCart();
    const currentTotal = cart.total_price / 100;
    const { leftForText, andText, appliedText } = VOOCART.config.blocks.rewardBar.settings;
    const sortedRewards = VOOCART.config.blocks.rewardBar.settings.rewards.sort(this.sortByTargetTotal);
    const nextReward = sortedRewards.find((reward) => currentTotal < Number(reward.targetTotal));
    const appliedRewards = sortedRewards.filter((reward) => currentTotal > reward.targetTotal);
    const spendMessageEl = this.querySelector('.voo-cart-drawer__reward-bar-message-spend');
    const appliedRewardsMessageEl = this.querySelector('.voo-cart-drawer__reward-bar-message-applied');

    const getAppliedRewardsMessage = (appliedRewards) => {
      let joinedRewardsString = '';
      if (appliedRewards.length < 3) {
        joinedRewardsString = appliedRewards.map((reward) => reward.title).join(` ${andText} `);
      } else {
        const appliedRewardsWithoutLastOne = appliedRewards.slice(0, -1);
        joinedRewardsString =
          appliedRewardsWithoutLastOne.map((reward) => reward.title).join(', ') +
          ` ${andText} ` +
          appliedRewards[appliedRewards.length - 1].title;
      }

      return joinedRewardsString + ` ${appliedText}`;
    };

    if (appliedRewardsMessageEl) appliedRewardsMessageEl.innerText = getAppliedRewardsMessage(appliedRewards);

    if (!nextReward) {
      spendMessageEl && spendMessageEl.classList.add('voo-hidden');
      appliedRewardsMessageEl && appliedRewardsMessageEl.classList.remove('voo-hidden');
      return;
    }

    spendMessageEl && spendMessageEl.classList.remove('voo-hidden');

    if (appliedRewards.length && appliedRewardsMessageEl) {
      appliedRewardsMessageEl.classList.remove('voo-hidden');
    } else {
      appliedRewardsMessageEl.classList.add('voo-hidden');
    }

    const moneyToSpendToGetTheNextReward = Number(nextReward.targetTotal) - currentTotal;

    const spendMessageMarkup = `<span class="money-to-spend money">${Shopify.formatMoney(
      moneyToSpendToGetTheNextReward * 100
    )}</span> ${leftForText} <span class="voo-cart-drawer__reward-bar-message-reward-name">${nextReward.title}</span>`;

    if (spendMessageEl) spendMessageEl.innerHTML = spendMessageMarkup;
  }

  getRewardsMarkup() {
    const sortedRewards = VOOCART.config.blocks.rewardBar.settings.rewards.sort(this.sortByTargetTotal);

    const lastRewardTargetTotal = sortedRewards[sortedRewards.length - 1].targetTotal;

    const defineRewardPositionOnProgressLine = (rewardTargetTotal, maxRewardTargetTotal) => {
      const positionFromLeftInPercentage = (100 * rewardTargetTotal) / maxRewardTargetTotal;

      if (positionFromLeftInPercentage === 100) return 'right: 0;';
      return `left: ${positionFromLeftInPercentage}%;`;
    };

    const rewardsTitleMarkup = sortedRewards.reduce(
      (markup, reward) =>
        markup +
        `<p class="voo-cart-drawer__reward-name" style="${defineRewardPositionOnProgressLine(
          reward.targetTotal,
          lastRewardTargetTotal
        )}">${window.countryCurrency.symbol + reward.targetTotal}</p>
        `,
      ''
    );

    const progressLineWrapEl = this.querySelector('.voo-cart-drawer__reward-bar-line-wrap');
    if (progressLineWrapEl) progressLineWrapEl.insertAdjacentHTML('beforeend', rewardsTitleMarkup);
  }
}

customElements.define('voo-cart-drawer-reward-bar', VooCartDrawerRewardBar);

class VooCartDrawerBogo extends HTMLElement {
  constructor() {
    super();

    this.productVariantsToCheckInCartForGift();
  }

  async productVariantsToCheckInCartForGift() {
    const cart = await getCart();
    const productPairs = VOOCART.config.blocks.bogo.settings.pairs;

    const pairsWithXYProductsStatus = productPairs.map((pair) => {
      const XProductsInCart = cart.items.filter((item) => {
        if (pair.productXVariants.length === 0) {
          return pair.productX.id === item.product_id;
        }

        const rightXVariant = pair.productXVariants.find(
          (productVariant) => item.variant_id === Number(productVariant)
        );
        return rightXVariant;
      });

      const YProductsInCart = cart.items.filter((item) => {
        if (pair.productYVariants.length === 0) {
          return pair.productY.id === item.product_id;
        } else {
          const rightYVariant = pair.productYVariants.find(
            (productVariant) => item.variant_id === Number(productVariant)
          );
          return rightYVariant;
        }
      });

      return {
        ...pair,
        XProductIsInCart: XProductsInCart.length !== 0,
        YProductIsInCart: YProductsInCart.length !== 0,
      };
    });

    const pairsWithAvailableGifts = pairsWithXYProductsStatus.filter((pair) => pair.XProductIsInCart);

    const isGiftProductInCart = pairsWithXYProductsStatus.find((pair) => pair.YProductIsInCart);

    if (isGiftProductInCart || pairsWithAvailableGifts.length === 0) {
      this.classList.add('voo-hidden');
      return;
    } else {
      this.classList.remove('voo-hidden');
    }

    const giftProductsToRender = pairsWithAvailableGifts.map((pair) =>
      pair.productYVariants.length === 0
        ? pair.productY
        : {
          ...pair.productY,
          variants: pair.productY.variants.filter((variant) =>
            pair.productYVariants.find((availableVariant) => Number(availableVariant) === variant.id)
          ),
        }
    );

    this.renderGiftProducts(giftProductsToRender);
  }

  addGiftProduct(e) {
    const bogoProductSelect = e.target
      .closest('.voo-cart-drawer__bogo-item')
      ?.querySelector('.voo-cart-drawer__bogo-product-select');

    if (!bogoProductSelect) return;

    const giftVariantId = Number(bogoProductSelect.value);
    document.querySelector('voo-cart-drawer').addProducts([{ id: giftVariantId, quantity: 1 }]);
  }

  addClickListener() {
    this.querySelectorAll('.voo-cart-drawer__bogo-product-add').forEach((btn) =>
      btn.addEventListener('click', this.addGiftProduct)
    );
  }

  addSelectChangeListener() {
    const giftProductSelectElems = this.querySelectorAll('.voo-cart-drawer__bogo-product-select');

    const onVariantChange = (e) => {
      const chosenVariant = Number(e.target.value);
      const productVariantEl = e.target.closest('[data-variant-id]');
      const bogoProductPrice = productVariantEl.querySelector('.voo-cart-drawer__bogo-product-price');
      const oldVariant = Number(productVariantEl.dataset.variantId);
      const productId = Number(productVariantEl.dataset.productId);

      if (oldVariant === chosenVariant) return;

      const pairWithNewVariantData = VOOCART.config.blocks.bogo.settings.pairs.find(
        (pair) => pair.productY.id === productId
      );
      const newVariantData = pairWithNewVariantData.productY.variants.find((variant) => variant.id === chosenVariant);

      if (bogoProductPrice) bogoProductPrice.innerText = Shopify.formatMoney(newVariantData.price);
    };

    giftProductSelectElems.forEach((giftProductSelectEl) =>
      giftProductSelectEl.addEventListener('change', onVariantChange)
    );
  }

  renderGiftProducts(products) {
    const giftProductsMarkup = products.reduce((markup, product) => {
      return (
        markup +
        `
      <li class="voo-cart-drawer__bogo-item" data-product-id="${product.id}" data-variant-id="${product.variants[0].id
        }">
        <img class="voo-cart-drawer__bogo-image" src=${product.featured_image} alt=${product.title
        } heigth="150" width="150"/>
        <h4 class="voo-cart-drawer__bogo-product-name">${product.title}</h4>
        <div class="voo-cart-drawer__bogo-product-prices">
          <span class="voo-cart-drawer__bogo-product-price">${Shopify.formatMoney(product.price)}</span>
          <span class="voo-cart-drawer__bogo-product-free">Free</span>
        </div>
        <select class="voo-cart-drawer__bogo-product-select voo-select">
          ${product.variants.reduce(
          (optionsMarkup, variant) => optionsMarkup + `<option value="${variant.id}">${variant.title}</option>`,
          ''
        )}
        </select>
        <button class="voo-cart-drawer__bogo-product-add">Add</button>
      </li>
    `
      );
    }, '');

    this.querySelector('.voo-cart-drawer__bogo-list').innerHTML = giftProductsMarkup;

    this.addClickListener();
    this.addSelectChangeListener();
  }
}

customElements.define('voo-cart-drawer-bogo', VooCartDrawerBogo);
class VooCartDrawerDiscount extends HTMLElement {
  constructor() {
    super();

    this.applyBtn = this.querySelector('#apply-discount-btn');
    this.discountCodeError = this.querySelector('#discount-code-error');
    this.discountCodeInput = this.querySelector('#discount-code-input');

    this.addEventListeners();
  }

  addEventListeners() {
    if (this.applyBtn) this.applyBtn.disabled = true;

    const checkoutContainer = document.createElement('div');
    document.body.appendChild(checkoutContainer);

    if (localStorage.discountCode) this.applyDiscount(JSON.parse(localStorage.discountCode).code);

    const onApplyBtnClick = (e) => {
      e.preventDefault();
      this.applyDiscount(this.discountCodeInput.value);
    };

    const disableApplyButton = this.disableApplyBtn.bind(this);

    if (this.applyBtn) this.applyBtn.addEventListener('click', onApplyBtnClick.bind(this));
    if (this.discountCodeInput) this.discountCodeInput.addEventListener('input', (e) => disableApplyButton(e));
  }

  onClearBtnClick = (e) => {
    e.preventDefault();
    this.clearDiscount();
    this.applyDiscount('');
  };

  disableApplyBtn(e) {
    if (!this.applyBtn) return;

    if (e.target.value.length === 0) {
      this.applyBtn.disabled = true;
    } else if (e.target.value.length > 0 && this.applyBtn.disabled) {
      this.applyBtn.disabled = false;
    }
  }

  clearDiscount() {
    if (this.discountCodeError) this.discountCodeError.innerHTML = '';
    this.clearLocalStorage();
  }

  clearLocalStorage() {
    localStorage.removeItem('discountCode');
  }

  removeDiscountCode(codeToRemove) {
    let existing = [];

    try {
      const parsed = JSON.parse(localStorage.getItem('discountCode'));
      if (Array.isArray(parsed)) {
        existing = parsed;
      } else if (parsed && typeof parsed === 'object') {
        existing = [parsed];
      }
    } catch (e) {
      existing = [];
    }

    const updated = existing.filter(entry => entry.code !== codeToRemove);
    localStorage.setItem('discountCode', JSON.stringify(updated));

    // Застосовуємо залишок
    const remainingCodes = updated.map(entry => entry.code).join(',');
    this.applyDiscount(remainingCodes); // ❗ тут передаємо всі залишкові коди
  }


  async applyDiscount(codeToApply) {
    const { applyBtnText, applyBtnLoadingText, errorMessage } = VOOCART.config.blocks.discountApplicator.settings;
    const code = (codeToApply || '').trim();

    // ⛑ витягуємо та нормалізуємо список кодів
    let existingCodes = JSON.parse(localStorage.getItem('discountCode')) || [];

    if (!Array.isArray(existingCodes)) {
      existingCodes = [existingCodes];
    }

    // якщо код передано й він новий — додаємо
    if (code && !existingCodes.find(entry => entry.code === code)) {
      existingCodes.push({ code, totalCart: 0 });
      localStorage.setItem('discountCode', JSON.stringify(existingCodes));
    }

    // обʼєднуємо всі коди через кому
    const allCodes = existingCodes.map(entry => entry.code).join(',');

    // показуємо loader
    if (this.applyBtn && code) {
      this.applyBtn.innerHTML = `${applyBtnLoadingText} <div class="loader"></div>`;
      this.applyBtn.disabled = true;
    }

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ discount: allCodes })
      });

      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

      const updatedCart = await response.json();

      // очищаємо поле вводу
      this.discountCodeInput.value = '';
      if (this.discountCodeError) this.discountCodeError.innerHTML = '';

      // оновлюємо cart
      const cartDrawerEl = document.querySelector('voo-cart-drawer');
      const rewardBarEl = document.querySelector('voo-cart-drawer-reward-bar');

      if (cartDrawerEl) {
        cartDrawerEl.renderCartDrawerFooter();
        cartDrawerEl.renderCartDrawerItems();
      }

      if (rewardBarEl) rewardBarEl.updateRewardBar();

      window.dispatchEvent(new Event('resize'));

      // оновлюємо з totalCart (не обов’язково)
      const updatedList = existingCodes.map(entry => ({
        code: entry.code,
        totalCart: updatedCart.total_price,
      }));
      localStorage.setItem('discountCode', JSON.stringify(updatedList));

    } catch (error) {
      console.error('applyDiscount error:', error);
      if (this.discountCodeError) this.discountCodeError.innerHTML = errorMessage;
    } finally {
      if (this.applyBtn) {
        this.applyBtn.innerHTML = applyBtnText;
        this.applyBtn.disabled = this.discountCodeInput.value ? false : true;
      }
    }
  }


}

customElements.define('voo-cart-drawer-discount', VooCartDrawerDiscount);

new VooCart();
